// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { MessageProcessorBase } from './MessageProcessorBase';
import { RefreshTokenMesage } from '../Messages/RefreshTokenMesage';
export class RefreshTokenProcessor extends MessageProcessorBase {
    constructor(parentDecoder) {
        super();
        this.decoder = parentDecoder;
    }
    decode(fieldSet) {
        const message = new RefreshTokenMesage(fieldSet);
        return [message];
    }
}
